import { storiesOf } from '@storybook/vue';
import { withKnobs, boolean } from '@storybook/addon-knobs';
import { EventBus } from '@/main/eventBus';
import { PageMode } from '@/main/utils/pageMode';

const stories = storiesOf('Components/DMS/Form', module);
const notes = '- [tiptap komponenta](https://www.google.com)\n'
	+ '- [feature request - clear formatting](https://github.com/scrumpy/tiptap/issues/101)\n';

stories
	.addDecorator(withKnobs)
	.add('RichText', () => ({
		template: '<div> <dms-rich-text :value.sync="value"/> <div> Vysledna hodnota: {{value}} </div></div> ',
		data() {
			return {
				value: null,
			};
		},
		props: {
			disabled: {
				default: boolean('Disabled', false),
			},
		},
		mounted() {
			EventBus.$emit('Mode', PageMode.EDIT);
		},
	}), { notes });
